import React from 'react';

export default function Logo({ className = "text-2xl" }) {
  return (
    <span className={`${className} font-extrabold tracking-tighter bg-clip-text text-transparent bg-gradient-to-r from-blue-600 to-cyan-500 leading-none inline-block`}>
      Appfred
    </span>
  );
}